import * as React from "react";
import { Confirm } from "react-admin";
import { TextField as MuiTextField } from "@mui/material";
import { MAX_NOTE_LENGTH } from "../utils/Validations";

export const DeactivationNoteDialog = ({
  isOpen,
  initialNote = "",
  loading = false,
  onConfirm,
  onClose,
}) => {
  const [note, setNote] = React.useState(initialNote);

  React.useEffect(() => {
    if (isOpen) setNote(initialNote);
  }, [isOpen, initialNote]);

  const confirm = () => {
    const edited = note.trim();
    onConfirm(edited === initialNote ? undefined : edited);
  };

  return (
    <Confirm
      isOpen={isOpen}
      loading={loading}
      title="Desactivar usuario"
      content={
        <>
          ¿Estás seguro de desactivar este usuario?
          <MuiTextField
            label="Nota (opcional)"
            helperText="Queda guardada en el usuario y en su historial"
            value={note}
            onChange={(event) => setNote(event.target.value)}
            margin="dense"
            multiline
            minRows={2}
            fullWidth
            slotProps={{ htmlInput: { maxLength: MAX_NOTE_LENGTH } }}
          />
        </>
      }
      onConfirm={confirm}
      onClose={onClose}
    />
  );
};

export default DeactivationNoteDialog;
